import { computed, getCurrentInstance, ref, watch } from 'vue';
export function useVModel(props, key, options = {}) {
    const vm = getCurrentInstance();
    const { passive = true, eventName, defaultValue, emit = vm === null || vm === void 0 ? void 0 : vm.emit } = options;
    const event = eventName !== null && eventName !== void 0 ? eventName : `update:${key.toString()}`;
    const getValue = () => (props[key] != null ? props[key] : defaultValue);
    if (!passive) {
        return computed({
            get() {
                return getValue();
            },
            set(value) {
                emit(event, value);
            },
        });
    }
    const proxy = ref(getValue());
    watch(() => props[key], () => {
        proxy.value = getValue();
    });
    watch(() => proxy.value, (newValue) => {
        emit(event, newValue);
    });
    return proxy;
}
